import { useNavigate } from "react-router-dom";

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "40px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      <button onClick={() => navigate("/")} style={btn}>Back to Home</button>
      <h1>Privacy Policy</h1>
      <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
        We collect basic information such as name, phone number, address, and email for account creation, booking management, and service delivery.
      </p>
      <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
        We do not sell personal information. Data may be used to improve service quality and platform operations.
      </p>
    </div>
  );
}
const btn = { marginBottom: "20px", padding: "10px 16px", border: "none", background: "black", color: "white", borderRadius: "8px", cursor: "pointer" };
export default PrivacyPolicy;
